import React, { useEffect, useState } from "react";
import { Button, Select, Input } from "antd";
import { RiSendPlaneLine } from "react-icons/ri";
import { sendNotification } from "../../../../Service/RM";
import RadioButton from "../../../../reusableUI/radioBtns";
import { getLookupData } from "../../../../Service/lookup";
import { showToast } from "../../../../reusableUI/toaster";
import Loader from "../../../../reusableUI/loader";

const { Option } = Select;

const Notification = () => {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [loading, setLoading] = useState(false);
  const [casedata, setCase] = useState([]);
  const [toastMsg, setToastMsg] = useState(null);

  const caseDefaults = {
    "Incomplete Profile Users": {
      title: "Profile Completion Required",
      message:
        "To proceed, it is essential that you complete your profile. Please take a moment to fill in all the required fields to ensure a smooth process.",
    },
    "Aadhaar Reupload Users": {
      title: "Aadhaar Document Update Needed",
      message:
        "We require you to re-upload your Aadhaar details for verification purposes. This is necessary to maintain the integrity of your account and ensure compliance with our policies.",
    },
    "Certificate Reupload Users": {
      title: "Certificate Update Required",
      message:
        "Please re-upload your certificate as it is crucial for the processing of your application. Ensure that the document is clear and legible to avoid any delays.",
    },
    "Unsigned Contract Users": {
      title: "Contract Signature Needed",
      message:
        "To continue with our services, it is imperative that you sign your contract. Please review the document carefully and provide your signature at your earliest convenience.",
    },
    "Unpaid Fee Users": {
      title: "Outstanding Fees",
      message:
        "Your account currently has overdue fees that need to be addressed. Please make the necessary payment to avoid any interruptions in your services and to continue enjoying our offerings.",
    },
    "Inactive Login Users": {
      title: "Account Inactive",
      message:
        "Your account has been marked as inactive. To regain access, please log in using your credentials. If you encounter any issues, feel free to reach out for assistance.",
    },
    "All Users": {
      title: "General Update for All Users",
      message:
        "We have an important update that affects all users. Please take a moment to read through this information as it may impact your experience with our services.",
    },
    "All Patients": {
      title: "Important Update for All Patients",
      message:
        "Attention all patients: we have a significant update that you need to be aware of. Please read the following information carefully to stay informed about your care and services.",
    },
    "All Nurses": {
      title: "Important Update for All Nurses",
      message:
        "Dear nurses, we have an important announcement that requires your attention. Please review the details below to ensure you are up to date with the latest information relevant to your role.",
    },
    "All Physiotherapists": {
      title: "Important Update for All Physiotherapists",
      message:
        "This is a crucial update for all physiotherapists. Please take the time to read through the following information to stay informed about any changes or important notices.",
    },
    "All Specialist": {
      title: "Important Update for All Specialists",
      message:
        "All specialists are encouraged to review this important update. It contains vital information that may affect your practice and the services you provide.",
    },
  };

  useEffect(() => {
    getCase();
  }, []);

  const getCase = async () => {
    const result = await getLookupData();
    if (result.error === false) {
      setCase(result.data);
    } else {
      console.log("Error fetching");
    }
  };

  const caseList = casedata.filter((item) => item.type === "notification case");

  const handleCaseChange = (selectedCase) => {
    setSelectedOption(selectedCase);

    if (caseDefaults[selectedCase]) {
      setTitle(caseDefaults[selectedCase].title);
      setMessage(caseDefaults[selectedCase].message);
    } else {
      setTitle("");
      setMessage("");
    }
  };

  const handleSend = async () => {
    const data = {
      useCase: selectedOption,
      title: title,
      message: message,
    };

    setLoading(true);

    try {
      let res = await sendNotification(data);
      setLoading(false);

      if (res && res.error === false) {
        showToast(res.message, "Success");
        setSelectedOption("");
        setTitle("");
        setMessage("");
        console.log(res);
      } else {
        showToast("Messages not delivered", "Error");
      }
    } catch (error) {
      setLoading(false);
      console.error("Error sending notification:", error);
    }
  };

  return (
    <>
      {loading ? (
        <div className="">
          <Loader loading={loading} />
        </div>
      ) : (
        <div className="bg-[#F3F6F5]">
          <div className="w-[98%] flex flex-col items-center justify-center bg-white rounded-2xl overflow-hidden h-[85vh] shadow-lg m-2">
            <p className="mb-4 text-[16px] text-blue-600 text-bold px-4 py-1">
              Notification Center
            </p>
            <div className="flex flex-col justify-center w-[60%] bg-white border border-1 border-blue-300 rounded-2xl overflow-hidden h-[60vh] shadow-lg gap-4 p-8">
              <div className="flex flex-col gap-2">
                <div className="w-full">
                  <Select
                    value={selectedOption || undefined}
                    onChange={handleCaseChange}
                    placeholder="Select Case"
                    className="w-full text-[12px] text-[blue] border border-gray-500 focus:border-blue-400 focus:ring-2 focus:ring-blue-400 rounded-md"
                  >
                    {caseList.map((option) => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                </div>
              </div>

              {/* <div className="flex gap-3 ">
                <RadioButton
                  label="Push Notification"
                  value="push notification"
                  selectedOption={selectedMsgOption}
                  onChange={handleRadioChange}
                />
                <RadioButton
                  label="SMS"
                  value="sms"
                  selectedOption={selectedMsgOption}
                  onChange={handleRadioChange}
                />
              </div> */}

              <div className="flex flex-col gap-2">
                <Input
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="Enter Title"
                  className="w-full border border-gray-500"
                />
              </div>

              <div className="flex flex-col gap-2">
                <Input.TextArea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Enter Message"
                  rows={4}
                  className="w-full border border-gray-500"
                  maxLength={1500}
                />
              </div>

              <div className="flex justify-center mt-4">
                <Button
                  type="primary"
                  icon={<RiSendPlaneLine />}
                  onClick={handleSend}
                  disabled={!title || !message || !selectedOption || loading}
                >
                  Send
                </Button>
              </div>
            </div>
          </div>
          {/* {toastMsg && <Toaster action={toastMsg.action} msg={toastMsg.msg} />} */}
        </div>
      )}
    </>
  );
};

export default Notification;
